export default {
      id: "i-book-open-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/sprite.svg#i-book-open",
      toString: function () {
        return this.url;
      }
    }